<template>
  <v-container fluid>
    <gg-card>
      <gg-card-header>
        What to Expect
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12">
            <p>
              If you already have a website at another hosting provider, GreenGeeks offers its customers a free migration
              by our professional site migration team.
            </p>
            <p>
              We'll ask you to provide a few details about your previous hosting account, so we can login to access the
              existing content in order to copy it over to your GreenGeeks account.
            </p>
          </v-col>
          <v-col cols="12" class="py-0">
            <h4>How Long Does It Take?</h4>
          </v-col>
          <v-col cols="12">
            <p>
              Once the migration request form has been completed, our team will review your request and process your
              migration on a first come, first serve basis. The average turnaround time is 24 to 48 hours.
            </p>
          </v-col>
          <v-col cols="12" class="py-0">
            <h4>More Information</h4>
          </v-col>
          <v-col cols="12">
            <p>
              Refer to our <a href='https://www.greengeeks.com/website-transfer' target='_blank'>Website Transfer
              Guide</a> for more information.
            </p>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>
  </v-container>
</template>

<script>
export default {
  name: 'MigrateWebsite'
}
</script>
